<template>
  <div v-if="crewMember" :class="['flex gap-4']">
    <div class="flex-shrink-0">
      <Avatar
        :alt="crewMember.full_name"
        :status="'offline'"
        :initials="getInitials(crewMember)"
      />
    </div>

    <div class="flex flex-col truncate text-left">
      <div
        class="truncate font-medium text-gray-900"
        :title="crewMember.full_name"
      >
        {{ crewMember.full_name }}
      </div>
      <div
        class="text-xs text-gray-500 truncate font-normal flex items-center gap-1"
        :title="crewMember.department.name"
      >
        {{ capitalize(crewMember.skill_level || "--") }}
        <div v-if="crewMember.department.name">•</div>
        {{ crewMember.department.name }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Avatar from "@/components/Seranova/Indicator/Avatar.vue";
import { capitalize, getInitials } from "@/mixins";

defineProps<{
  crewMember: any;
}>();
</script>

<style scoped></style>
